
























import { computed, defineComponent } from "@vue/composition-api";
import { QuickTip } from "@/types";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseIconButton from "@/components/BaseIconButton";

export default defineComponent({
  name: "QuickTipsItem",
  components: { BaseIconButton, BaseIcon },
  props: {
    item: { type: Object as () => QuickTip, required: true },
    type: { type: String as () => "warning" | "info" | "success" | "neutral" | "secondary", default: "info" },
    showCloser: { type: Boolean },
  },
  setup(props) {
    const classes = computed(() => ({
      ["__" + props.item.type || props.type]: true,
      "__show-closer": props.showCloser,
    }));
    return {
      classes,
    };
  },
});
